import React from "react";
import { connect } from "react-redux";
import { modal } from "@mc/mc-legacy";
import CustomPageLayout from "./CustomPageLayout";
import AdminMenu from "../administrace/lists/components/AdminMenu";
import IconButton from "../components/IconButton";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
import * as configurationActions from "../actions/configurationActions";
import FlowConfigurationForm from "../administrace/forms/FlowConfigurationForm";
import FlowConfigurationsList from "../administrace/lists/components/FlowConfigurationsList";
import {cleanSteps} from "../utils/appUtils";

/**
 * Správa podepisujících.
 */
class FlowConfigurationsPage extends React.Component {
  handleCreateApprover = () => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.show(
          FlowConfigurationForm,
        {
          onSubmit: (data) => {
              const { steps, ...other } = data;
              const dataFinal = {
                  ...other,
                  steps: cleanSteps(steps),
              };
              return QSignAdminApi.createFlowConfiguration(dataFinal);
          },
          onSubmitSuccess: (result, dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(configurationActions.fetchFlowConfigurationsIfNeeded(true));
          },
          initialValues: { steps: [{name: "Krok č. 1", everyone: false, approvers: [{pracovnikId: null}]}] },
        },
        "Nová konfigurace",
        {}
      )
    );
  };

  render() {
    return (
      <CustomPageLayout
        header
        customHeaderButton={<IconButton icon="plus" title="Nová konfigurace" onClick={this.handleCreateApprover} />}
        headerButton={false}
        searchField={false}
        title="Schvalovací konfigurace"
        menu={<AdminMenu />}
      >
        <FlowConfigurationsList />
      </CustomPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(FlowConfigurationsPage);
